import { cachedHttp } from "./httpService";

const apiEndPoint = "/gesturepresets/";

function getGesturePresets() {
  return cachedHttp.get(apiEndPoint);
}

export default getGesturePresets;
